<template>
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_20582_442204)">
      <path
        d="M9.32023 4.74621V8.1423L12.2097 9.83527C12.3553 9.92064 12.4602 10.059 12.5013 10.2198C12.5424 10.3807 12.5163 10.5509 12.4289 10.6931C12.3415 10.8352 12.1999 10.9376 12.0351 10.9778C11.8704 11.0179 11.6961 10.9925 11.5506 10.9071L8.35066 9.03215C8.25595 8.97658 8.17759 8.89801 8.1232 8.8041C8.0688 8.71018 8.04023 8.60411 8.04027 8.49621V4.74621C8.04027 4.58045 8.10769 4.42148 8.22771 4.30427C8.34773 4.18706 8.51052 4.12121 8.68025 4.12121C8.84998 4.12121 9.01276 4.18706 9.13278 4.30427C9.2528 4.42148 9.32023 4.58045 9.32023 4.74621ZM16.36 2.87121C16.1903 2.87121 16.0275 2.93706 15.9075 3.05427C15.7875 3.17148 15.72 3.33045 15.72 3.49621V4.90246C15.2121 4.32746 14.6937 3.77355 14.1105 3.19699C13.0432 2.15458 11.685 1.44243 10.2057 1.14954C8.72631 0.856642 7.19137 0.995991 5.79264 1.55017C4.39392 2.10435 3.19343 3.04878 2.34119 4.26546C1.48894 5.48214 1.02273 6.91712 1.00081 8.39108C0.978889 9.86504 1.40223 11.3126 2.21793 12.553C3.03363 13.7933 4.20553 14.7714 5.58718 15.365C6.96884 15.9586 8.49899 16.1415 9.98643 15.8906C11.4739 15.6398 12.8527 14.9665 13.9505 13.9548C14.0116 13.8984 14.0608 13.8307 14.0952 13.7558C14.1295 13.6808 14.1485 13.5999 14.1508 13.5178C14.1532 13.4357 14.139 13.3539 14.109 13.2771C14.079 13.2004 14.0339 13.1301 13.9761 13.0704C13.9183 13.0107 13.8491 12.9627 13.7723 12.9291C13.6955 12.8956 13.6127 12.8771 13.5286 12.8748C13.4445 12.8724 13.3608 12.8863 13.2822 12.9156C13.2036 12.9449 13.1317 12.989 13.0705 13.0454C12.1554 13.8877 11.0064 14.448 9.76719 14.6563C8.52794 14.8647 7.25329 14.7119 6.10241 14.2171C4.95154 13.7222 3.97544 12.9072 3.29602 11.8739C2.6166 10.8405 2.26395 9.63456 2.28213 8.40664C2.30031 7.17871 2.6885 5.98323 3.39822 4.96947C4.10795 3.95571 5.10776 3.16861 6.2728 2.70645C7.43784 2.2443 8.71648 2.12757 9.94905 2.37084C11.1816 2.61411 12.3135 3.20661 13.2033 4.07434C13.8545 4.71809 14.4249 5.3384 15.0001 5.99621H13.1601C12.9904 5.99621 12.8276 6.06206 12.7076 6.17927C12.5876 6.29648 12.5201 6.45545 12.5201 6.62121C12.5201 6.78697 12.5876 6.94594 12.7076 7.06315C12.8276 7.18036 12.9904 7.24621 13.1601 7.24621H16.36C16.5298 7.24621 16.6925 7.18036 16.8126 7.06315C16.9326 6.94594 17 6.78697 17 6.62121V3.49621C17 3.33045 16.9326 3.17148 16.8126 3.05427C16.6925 2.93706 16.5298 2.87121 16.36 2.87121Z"
        class="fill"
      />
    </g>
    <defs>
      <clipPath id="clip0_20582_442204">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.782959 0.699585)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ResetIcon",
});
</script>

<style scoped lang="scss">
@use "./icon.scss";
</style>
